import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as dynamicListActions from '../../actions/dynamic_list';
import Autocomplete from './autocomplete';
//import DateFilter from '../common/dateFilter';
import DateFilter from './dateFilterInit';
import RowTimePicker from './timePicker';
import Validation from './validation';

class TableRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDriver: false,
      dataRow: []
    };
  }

  validateDate = (filter, date) => {
    let dateValue;
    if (filter) {
      dateValue = filter;
    } else if (date) {
      dateValue = date.substring(0, 10);
    } else {
      dateValue = new Date();
    }
    return dateValue;
  };

  handleIsDriver = () => {
    let aliasArr = this.props.test ? this.props.test.data : [];
    let isDriver = aliasArr.map(item => item.alias).includes(this.props.driverName);
    return isDriver;
  };

  render() {
    return (
      <React.Fragment>
        {this.props.dataRow.map((item, i) => (
          <tr
            key={`row-${item.id}`}
            id={`row-${i}`}
            className={`${
              this.props.isDriver
                ? this.props.isDriver.includes(item.person) | (item.person == null)
                  ? 'bg-red-color'
                  : 'bg-yellow-color'
                : ''
            }`}
          >
            <td className="border-left-style">
              <span
                className={`${
                  this.props.isDriver
                    ? this.props.isDriver.includes(item.person) | (item.person == null)
                      ? 'border-tr-left left-bd-color'
                      : 'border-tr-left left-bd-color-green'
                    : 'border-tr-left left-bd-color'
                }`}
              />
              <input id={`homologation-id-${i}`} type="hidden" data-homologation="ok" />
              <div className="box-form">
                <Autocomplete
                  value={item.person}
                  id={`au-${i}`}
                  correlativo={`${i}`}
                  alias="alias"
                  aliasTwo="code"
                  select="alias"
                  className="font-famiy-homologationDriver"
                  idItem="id"
                  filter={this.props.filter}
                  handleSubmit={this.props.handleSubmit}
                  handleSubmitAutoComplete={this.props.handleSubmitAutoComplete}
                  checkIfExist={this.props.checkIfExist}
                  handleDriverName={this.props.handleDriverName}
                  i={i}
                  handleChangeSelectedName={this.props.handleChangeSelectedName}
                />
              </div>
            </td>

            <td>
              <input id={`homologation-id-${i}`} type="hidden" data-homologation="ok" />
              <div className="box-form">
                <Autocomplete
                  value={item.equip}
                  id={`au-${i}`}
                  correlativo={`${i}`}
                  alias="alias"
                  aliasTwo="code"
                  select="alias"
                  className="font-famiy-homologationDriver"
                  idItem="id"
                  filter={this.props.filter}
                  handleSubmit={this.props.handleSubmit}
                  handleSubmitAutoComplete={this.props.handleSubmitAutoComplete}
                />
              </div>
            </td>
            <td>
              <div className="test-allocator">
                <div className="box-form box-form-size">
                  <i className="fal fa-calendar-alt fal-second" />

                  <DateFilter
                    asignDate={item.startDate ? item.startDate.fechaStartFinal : null}
                    dif={0}
                    id="date-start"
                    handleSubmit={this.props.handleSubmit}
                  />
                </div>
                <div className="box-form padding-left">
                  <i className="fal fa-clock fal-second" />
                  <RowTimePicker
                    time={item.timeStart}
                    handleSubmitTime={this.props.handleSubmitTime}
                  />
                </div>
              </div>
            </td>
            <td>
              <input id={`homologation-id-${i}`} type="hidden" data-homologation="ok" />
              <div className="test-allocator">
                <div className="box-form">
                  <i className="fal fa-calendar-alt fal-second" />
                  <DateFilter
                    asignDate={item.endDate ? item.endDate.fechaEndFinal : null}
                    dif={0}
                    id="date-end"
                    handleSubmit={this.props.handleSubmit}
                  />
                </div>
                <div className="box-form padding-left">
                  <i className="fal fa-clock fal-second" />
                  <RowTimePicker
                    time={item.timeEnd}
                    handleSubmitTime={this.props.handleSubmitTime}
                    empty={this.props.empty}
                  />
                </div>
                <div className="tooltip-wraper tooltip-asignador-delete">
                  <span className={`icon-edit`}>
                    <i
                      className="fas fa-times-circle "
                      onClick={this.props.deleteAsignation}
                      data-index={item.id}
                    />
                  </span>
                  <div className="toolti">
                    <span className="tooltptext">Eliminar</span>
                  </div>
                </div>
              </div>

              {this.props.isDriver ? (
                this.props.isDriver.includes(item.person) ? (
                  <Validation
                    close={this.props.close}
                    handleClose={this.props.handleClose}
                    index={i}
                    handleOpen={this.props.handleOpen}
                  />
                ) : (
                  ''
                )
              ) : (
                ''
              )}
            </td>
          </tr>
        ))}
      </React.Fragment>
    );
  }
}

TableRow.propTypes = {};

export default TableRow;



// WEBPACK FOOTER //
// ./source/client/components/allocator/tableRow.jsx